import React from 'react';
import Form from './Form';
import PropTypes from 'prop-types';
import Input from '../components/Fields/Input';
import FileInput from '../components/Fields/FileInput';
import { updateParticipant, uploadPhoto, deletePhoto } from '../redux/app';
import { connect } from 'react-redux';
import { navigateBack } from '../utils';

const FIELDS = [
  {
    name: 'name',
    component: Input,
    required: true,
  },
  {
    name: 'photo',
    component: FileInput,
  },
];

class ParticipantForm extends Form {
  constructor(props) {
    super(props);

    this.state = {
      values: this.mapProps(),
      didChange: false,
    };
  }

  nameSpace = 'app.tree.participant';

  isValid = () => !!this.state.values.name;

  mapProps = () => {
    return {
      name: this.props.defaultValues.name || '',
      photo: this.props.defaultValues.photo || '',
      bioVideo: this.props.defaultValues.bioVideo || '',
      bio: this.props.defaultValues.bio || '',
    };
  };

  render() {
    return (
      <Form.Wrapper>
        {this.createFields(FIELDS)}
        <this.Buttons />
      </Form.Wrapper>
    );
  }
}

ParticipantForm.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  openConfirm: PropTypes.func,
  goToParticipants: PropTypes.func,
  updateBracket: PropTypes.func,
  defaultValues: PropTypes.object,
};

const mapdispatchToProps = Form.mapDispatchToProps((dispatch, ownProps) => ({
  save: async ({ name, photo, bio, bioVideo }) => {
    try {
      const { payload } = await dispatch(
        updateParticipant(
          { name, bioVideo, bio },
          { treeId: ownProps.treeId, id: ownProps.id }
        )
      );
      if (photo && !/^http/.test(photo)) {
        await dispatch(
          uploadPhoto(photo, { treeId: ownProps.treeId, id: payload.data.id })
        );
      }

      if (ownProps.defaultValues.photo && !photo) {
        await dispatch(
          deletePhoto({ treeId: ownProps.treeId, id: payload.data.id })
        );
      }

      navigateBack();
    } catch (e) {}
  },
}));

export default connect(undefined, mapdispatchToProps)(ParticipantForm);
